<script>
    import {fade} from "svelte/transition"
    import {API_URL} from "../../../env";
    import {filter} from "../../js/stores";
    import {push, querystring, location} from "svelte-spa-router";

    import Select from "svelte-select";
    import {addAlert} from "../../js/alert";

    export let open = false;
    let selectedTab = 1;

    let diameters = []
    let profiles = []
    let widths = []
    let manufacturers = []

    let query = parseQuery($querystring)

    let filterValues = {
        type: query.type ? query.type.includes(",") ? query.type.split(",") : [query.type] : [],
        profile: query.profile ? query.profile.includes(",") ? query.profile.split(",") : [query.profile] : [],
        width: query.width ? query.width.includes(",") ? query.width.split(",") : [query.width] : [],
        diameter: query.diameter ? query.diameter.includes(",") ? query.diameter.split(",") : [query.diameter] : [],
        manufacturer: query.manufacturer ? query.manufacturer.includes(",") ? query.manufacturer.split(",") : [query.manufacturer] : [],
        season: query.season ? query.season.includes(",") ? query.season.split(",") : [query.season] : [],
    }

    console.log(filterValues);

    handleFilter(false)

    let typeValues = [
        { value:"OSOBNÍ", label:"Osobné" },
        { value:"MOTORKOVÉ", label:"Motorkové" },
        { value:"DODÁVKOVÉ", label:"Dodávkové" },
        { value:"4X4/SUV", label:"Terénne" },
        { value:"NÁKLADNÍ", label:"Nákladné" },
        { value:"Průmyslové", label:"Priemyselné" },
        { value:"ZEMĚDĚLSKÉ", label:"Poľnohospodárske" },
    ]

    let seasonValues = [
        { value:"Letní", label:"Letné" },
        { value:"Zimní", label:"Zimné" },
        { value:"Celoroční", label:"Celoročné" },
    ]

    // $: {
    //     query = parseQuery($querystring)
    //
    //     filterValues = {
    //         type: query.type || "",
    //         profile: parseInt(query.profile) || "",
    //         width: parseInt(query.width) || "",
    //         diameter: query.diameter || "",
    //         manufacturer: query.manufacturer || "",
    //         season: query.season || ""
    //     }
    // }

    async function ready() {
        const res = await fetch(API_URL+'/filterValues')
        const response = await res.json()

        diameters = response.diameters
        profiles = response.profiles
        widths = response.widths
        manufacturers = response.manufacturers

        filterValues = filterValues

        // filter out all null values
        diameters = diameters.filter(d => d.value !== null)
        profiles = profiles.filter(p => p.value !== null)
        widths = widths.filter(w => w.value !== null)
        manufacturers = manufacturers.filter(m => m.value !== null)
    }

    ready()

    function handleFilter(shouldPush = true) {
        // Ensure filterValues are updated from the URL query parameters
        let query = parseQuery($querystring);

        /*['type', 'width', 'profile', 'diameter', 'manufacturer', 'season'].forEach(key => {
            if (query[key]) {
                filterValues[key] = query[key].includes(",") ? query[key].split(",") : [query[key]];
            }
        });*/

        // Update filterValues to ensure they are in the correct format
        ['type', 'width', 'profile', 'diameter', 'manufacturer', 'season'].forEach(key => {
            if (filterValues[key] && Array.isArray(filterValues[key])) {
                filterValues[key] = filterValues[key].map(v => v.value || v).filter(v => v);
            }
        });

        // Create query object
        let queryObj = {...filterValues};

        // Remove empty values
        Object.keys(queryObj).forEach(key => {
            if (!queryObj[key] || queryObj[key].length === 0) {
                delete queryObj[key];
            }
        });

        // Create query string
        let queryString = Object.keys(queryObj)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(queryObj[k].join(',')))
            .join('&');

        filter.set(queryString);

        if (shouldPush) {
            push('/?' + $filter);
            open = false;

            addAlert("success", "Filter", "Filter bol úspešne aplikovaný", "check");

            // Scroll to #products
            document.getElementById('products').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
    }

    function updateFilter (string) {
        query = parseQuery(string)

        filterValues = {
            type: query.type ? query.type.includes(",") ? query.type.split(",") : [query.type] : [],
            profile: query.profile ? query.profile.includes(",") ? query.profile.split(",") : [query.profile] : [],
            width: query.width ? query.width.includes(",") ? query.width.split(",") : [query.width] : [],
            diameter: query.diameter ? query.diameter.includes(",") ? query.diameter.split(",") : [query.diameter] : [],
            manufacturer: query.manufacturer ? query.manufacturer.includes(",") ? query.manufacturer.split(",") : [query.manufacturer] : [],
            season: query.season ? query.season.includes(",") ? query.season.split(",") : [query.season] : [],
        }
    }

    $: if ($location === "/") updateFilter($querystring)

    /********************/

    function parseQuery(queryString) {
        let query = {};
        let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (let i = 0; i < pairs.length; i++) {
            let pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    }

    function manageAddRemoveWidth(width){
        if(filterValues.width === undefined || filterValues.width === null) filterValues.width = [];

        if(filterValues.width && filterValues.width.length > 0 && filterValues.width.find(fv => fv.value === width.value.toString())){
            let temp = filterValues.width;
            temp.splice(filterValues.width.indexOf(filterValues.width.find(fv => fv.value === width.value.toString())), 1);
            filterValues.width = [];
            filterValues.width = temp;
        }
        else {
            let temp = filterValues.width;
            temp.push({ value:width.value.toString(), label:`${width.value}mm` });
            filterValues.width = [];
            filterValues.width = temp;
        }
    }

    function manageAddRemoveProfile(profile){
        if(filterValues.profile === undefined || filterValues.profile === null) filterValues.profile = [];

        if(filterValues.profile && filterValues.profile.length > 0 && filterValues.profile.find(fv => fv.value === profile.value.toString())){
            let temp = filterValues.profile;
            temp.splice(filterValues.profile.indexOf(filterValues.profile.find(fv => fv.value === profile.value.toString())), 1);
            filterValues.profile = [];
            filterValues.profile = temp;
        }
        else {
            let temp = filterValues.profile;
            temp.push({ value:profile.value.toString(), label:`${profile.value}%` });
            filterValues.profile = [];
            filterValues.profile = temp;
        }
    }

    function manageAddRemoveDiameter(diameter){
        if(filterValues.diameter === undefined || filterValues.diameter === null) filterValues.diameter = [];

        if(filterValues.diameter && filterValues.diameter.length > 0 && filterValues.diameter.find(fv => fv.value === diameter.value.toString())){
            let temp = filterValues.diameter;
            temp.splice(filterValues.diameter.indexOf(filterValues.diameter.find(fv => fv.value === diameter.value.toString())), 1);
            filterValues.diameter = [];
            filterValues.diameter = temp;
        }
        else {
            let temp = filterValues.diameter;
            temp.push({ value:diameter.value.toString(), label:`R${diameter.value}` });
            filterValues.diameter = [];
            filterValues.diameter = temp;
        }
    }

    function manageAddRemoveType(type){
        if(filterValues.type === undefined || filterValues.type === null) filterValues.type = [];

        if(filterValues.type && filterValues.type.length > 0 && filterValues.type.find(fv => fv.value === type.value.toString())){
            let temp = filterValues.type;
            temp.splice(filterValues.type.indexOf(filterValues.type.find(fv => fv.value === type.value)), 1);
            filterValues.type = [];
            filterValues.type = temp;
        }
        else {
            let temp = filterValues.type;
            temp.push({ value: type.value, label: type.label });
            filterValues.type = [];
            filterValues.type = temp;
        }
    }

    function manageAddRemoveManufacturer(manufacturer){
        if(filterValues.manufacturer === undefined || filterValues.manufacturer === null) filterValues.manufacturer = [];

        if(filterValues.manufacturer && filterValues.manufacturer.length > 0 && filterValues.manufacturer.find(fv => fv.value === manufacturer.value.toString())){
            let temp = filterValues.manufacturer;
            temp.splice(filterValues.manufacturer.indexOf(filterValues.manufacturer.find(fv => fv.value === manufacturer.value.toString())), 1);
            filterValues.manufacturer = [];
            filterValues.manufacturer = temp;
        }
        else {
            let temp = filterValues.manufacturer;
            temp.push({ value:manufacturer.value.toString(), label:`${manufacturer.value}` });
            filterValues.manufacturer = [];
            filterValues.manufacturer = temp;
        }
    }

    function manageAddRemoveSeason(season){
        if(filterValues.season === undefined || filterValues.season === null) filterValues.season = [];

        if(filterValues.season && filterValues.season.length > 0 && filterValues.season.find(fv => fv.value === season.value.toString())){
            let temp = filterValues.season;
            temp.splice(filterValues.season.indexOf(filterValues.season.find(fv => fv.value === season.value)), 1);
            filterValues.season = [];
            filterValues.season = temp;
        }
        else {
            let temp = filterValues.season;
            temp.push({ value: season.value, label: season.label });
            filterValues.season = [];
            filterValues.season = temp;
        }
    }

    let preload = true;

    setTimeout(() => {
        preload = false;
    }, 500)

</script>

<dialog transition:fade={{duration: 100}}>
    <div class="dialog-background" on:click={() => open = false}></div>
    <div class="dialog-content">
        <div class="dialog-header">
            <div class="header-tabs">
                <button type="button" class:active={selectedTab === 1} on:click={() => {selectedTab = 1}}><i class="fad fa-fw fa-arrows-h mr-2"></i><span>Šírka</span></button>
                <button type="button" class:active={selectedTab === 2} on:click={() => {selectedTab = 2}}><i class="fad fa-fw fa-arrows-alt-v mr-2"></i><span>Profil</span></button>
                <button type="button" class:active={selectedTab === 3} on:click={() => {selectedTab = 3}}><i class="fad fa-fw fa-circle-half-stroke fa-rotate-270 mr-2"></i><span>Priemer</span></button>
                <button type="button" class:active={selectedTab === 4} on:click={() => {selectedTab = 4}}><i class="fad fa-fw fa-car mr-2"></i><span>Typ</span></button>
                <button type="button" class:active={selectedTab === 5} on:click={() => {selectedTab = 5}}><i class="fad fa-fw fa-snowflakes mr-2"></i><span>Sezóna</span></button>
                <button type="button" class:active={selectedTab === 6} on:click={() => {selectedTab = 6}}><i class="fad fa-fw fa-wrench mr-2"></i><span>Výrobca</span></button>
            </div>
            <button type="button" class="dc-close" on:click={() => open = false}>
                <i class="far fa-fw fa-xmark"></i>
            </button>
        </div>
        <div class="dc-content">
            <div class="row">
                {#if selectedTab === 1 || preload === true}
                    <div class="col-12">
                        <Select
                            placeholder="Vyberte šírku"
                            showChevron={true}
                            searchable={true}
                            multiple={true}
                            items={widths.map(v => { return { value:v.value.toString(), label:`${v.value}mm` } })}
                            bind:value={filterValues.width}
                        />
                    </div>
                    <div class="col-12">
                        <div class="dc-list">
                            {#each widths as width}
                                <button on:click={() => { manageAddRemoveWidth(width); }} type="button" class="dc-item" class:active={filterValues.width && filterValues.width.length > 0 && filterValues.width.find(fv => fv.value === width.value.toString())}>
                                    <span>{width.value}mm<i class="far fa-fw fa-check ml-2"></i></span>
                                </button>
                            {/each}
                        </div>
                    </div>
                {/if}
                {#if selectedTab === 2 || preload === true}
                    <div class="col-12">
                        <Select
                            placeholder="Vyberte profil"
                            showChevron={true}
                            searchable={true}
                            multiple={true}
                            items={profiles.map(v => { return { value:v.value.toString(), label:`${v.value}%` } })}
                            bind:value={filterValues.profile}
                        />
                    </div>
                    <div class="col-12">
                        <div class="dc-list">
                            {#each profiles as profile}
                                <button on:click={() => { manageAddRemoveProfile(profile); }} type="button" class="dc-item" class:active={filterValues.profile && filterValues.profile.length > 0 && filterValues.profile.find(fv => fv.value === profile.value.toString())}>
                                    <span>{profile.value}%<i class="far fa-fw fa-check ml-2"></i></span>
                                </button>
                            {/each}
                        </div>
                    </div>
                {/if}
                {#if selectedTab === 3 || preload === true}
                    <div class="col-12">
                        <Select
                            placeholder="Vyberte priemer"
                            showChevron={true}
                            searchable={true}
                            multiple={true}
                            items={diameters.map(v => { return { value:v.value.toString(), label:`R${v.value}` } })}
                            bind:value={filterValues.diameter}
                        />
                    </div>
                    <div class="col-12">
                        <div class="dc-list">
                            {#each diameters as diameter}
                                <button on:click={() => { manageAddRemoveDiameter(diameter); }} type="button" class="dc-item" class:active={filterValues.diameter && filterValues.diameter.length > 0 && filterValues.diameter.find(fv => fv.value === diameter.value.toString())}>
                                    <span>R{diameter.value}<i class="far fa-fw fa-check ml-2"></i></span>
                                </button>
                            {/each}
                        </div>
                    </div>
                {/if}
                {#if selectedTab === 4 || preload === true}
                    <div class="col-12">
                        <Select
                            placeholder="Vyberte typ"
                            showChevron={true}
                            searchable={true}
                            multiple={true}
                            items={typeValues}
                            bind:value={filterValues.type}
                        />
                    </div>
                    <div class="col-12">
                        <div class="dc-list">
                            {#each typeValues as type}
                                <button on:click={() => { manageAddRemoveType(type); }} type="button" class="dc-item" class:active={filterValues.type && filterValues.type.length > 0 && filterValues.type.find(fv => fv.value === type.value)}>
                                    <span>{type.label}<i class="far fa-fw fa-check ml-2"></i></span>
                                </button>
                            {/each}
                        </div>
                    </div>
                {/if}
                {#if selectedTab === 5 || preload === true}
                    <div class="col-12">
                        <Select
                                placeholder="Vyberte sezónu"
                                showChevron={true}
                                searchable={true}
                                multiple={true}
                                items={seasonValues}
                                bind:value={filterValues.season}
                        />
                    </div>
                    <div class="col-12">
                        <div class="dc-list">
                            <button on:click={() => { manageAddRemoveSeason(seasonValues[0]); }} type="button" class="dc-item" class:active={filterValues.season && filterValues.season.length > 0 && filterValues.season.find(fv => fv.value === "Letní")}>
                                <img src="/assets/img/icons/sun.svg" alt="Letné" class="mr-2">
                                <span>Letné<i class="far fa-fw fa-check ml-2"></i></span>
                            </button>
                            <button on:click={() => { manageAddRemoveSeason(seasonValues[1]); }} type="button" class="dc-item" class:active={filterValues.season && filterValues.season.length > 0 && filterValues.season.find(fv => fv.value === "Zimní")}>
                                <img src="/assets/img/icons/snowflake.svg" alt="Zimné" class="mr-2">
                                <span>Zimné<i class="far fa-fw fa-check ml-2"></i></span>
                            </button>
                            <button on:click={() => { manageAddRemoveSeason(seasonValues[2]); }} type="button" class="dc-item" class:active={filterValues.season && filterValues.season.length > 0 && filterValues.season.find(fv => fv.value === "Celoroční")}>
                                <img src="/assets/img/icons/wholeyear.svg" alt="Celoročné" class="mr-2">
                                <span>Celoročné<i class="far fa-fw fa-check ml-2"></i></span>
                            </button>
                        </div>
                    </div>
                {/if}
                {#if selectedTab === 6 || preload === true}
                    <div class="col-12">
                        <Select
                                placeholder="Vyberte výrobca"
                                showChevron={true}
                                searchable={true}
                                multiple={true}
                                items={manufacturers.map(v => { return { value:v.value.toString(), label:`${v.value}` } })}
                                bind:value={filterValues.manufacturer}
                        />
                    </div>
                    <div class="col-12">
                        <div class="dc-list">
                            {#each manufacturers as manufacturer}
                                <button on:click={() => { manageAddRemoveManufacturer(manufacturer); }} type="button" class="dc-item" class:active={filterValues.manufacturer && filterValues.manufacturer.length > 0 && filterValues.manufacturer.find(fv => fv.value === manufacturer.value)}>
                                    <span>{manufacturer.value}<i class="far fa-fw fa-check ml-2"></i></span>
                                </button>
                            {/each}
                        </div>
                    </div>
                {/if}
            </div>
        </div>
        <div class="dc-footer">
            <div class="d-flex">
                {#if selectedTab > 1}
                    <button class="btn btn-link" on:click={() => {selectedTab=selectedTab-1}}>Prechádzajúci krok</button>
                {/if}
            </div>
            <div class="d-flex">
                {#if selectedTab < 6}
                    <button class="btn btn-link mr-4" on:click={() => {selectedTab++}}>Ďalší krok</button>
                {/if}
                <button on:click={handleFilter} class="btn btn-primary"><i class="fad fa-fw fa-tire fa-lg mr-2"></i>Aplikovať filter</button>
            </div>
        </div>
    </div>
</dialog>

<style>
    dialog {
        position: fixed;
        z-index: 1000;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #00000080;
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        border: 0;
    }
    dialog .dialog-background {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 500;
    }
    dialog .dialog-content {
        height: 40rem;
        min-height: 70vh;
        max-height: 100%;
        width: 65vw;
        border-radius: 2rem;
        overflow: hidden;
        background-color: white;
        display: flex;
        flex-direction: column;
        z-index: 800;
    }
    dialog .dialog-header {
        height: 15%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1.5rem;
        border-bottom: 1px solid var(--color-slate-200);
    }
    dialog .dialog-header .dc-close {
        font-size: 1.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        margin: 1rem 0;
        width: 3rem;
        height: 3rem;
        min-width: 3rem;
        cursor: pointer;
        transition: .1s linear;
        color: var(--color-slate-600);
        background-color: var(--color-slate-50);
        border: 1px solid var(--color-slate-200);
    }
    dialog .dialog-header .dc-close:hover {
        color: var(--color-slate-900);
        border-color: var(--color-slate-400);
    }
    dialog .dialog-header .header-tabs {
        display: flex;
        gap: .75rem;
        overflow-x: auto;
        width: calc(100% - 4rem);
        height: 100%;
    }
    dialog .dialog-header .header-tabs button {
        font-size: 1.15rem;
        width: 9rem;
        cursor: pointer;
        font-weight: 600;
        font-family: Rubik, sans-serif;
        border-bottom: 2px solid transparent;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    dialog .dialog-header .header-tabs button:hover {
        background-color: var(--color-slate-50);
    }
    dialog .dialog-header .header-tabs button.active {
        border-color: var(--color-primary);
        background-color: var(--color-slate-50);
        color: var(--color-secondary);
    }

    @media (max-width: 767.98px) {

    }
    @media (max-width: 991.98px) {
        
    }

    dialog .dc-content {
        padding: 2rem;
        height: 70%;
        max-height: 68.5dvh;
        overflow-y: auto;
    }
    dialog .dc-content .dc-list {
        padding-top: 1.5rem;
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
        align-content: start;
    }
    dialog .dc-content .dc-list .dc-item {
        flex-grow: 1;
        position: relative;
        padding: 1rem 2.35rem 1rem 1.25rem;
        text-align: center;
        border: 1px solid;
        border-radius: 2.5rem;
        transition: .1s linear;
        display: flex;
        align-items: center;
        box-shadow: none !important;
        cursor: pointer;
        color: var(--color-slate-900);
        background-color: var(--color-slate-50);
        border-color: var(--color-slate-200);
    }
    dialog .dc-content .dc-list .dc-item:hover {
        background-color: var(--color-slate-100);
        border-color: var(--color-slate-400);
    }
    dialog .dc-content .dc-list .dc-item.active {
        color: white;
        background-color: var(--color-primary);
        border-color: var(--color-primary);
    }
    dialog .dc-content .dc-list .dc-item.active img {
        filter: brightness(0) invert(1);
    }
    dialog .dc-content .dc-list .dc-item i {
        opacity: 0;
        right: 1rem;
        position: absolute;
    }
    dialog .dc-content .dc-list .dc-item.active i {
        opacity: 1;
    }

    dialog .dc-footer {
        gap: 1.5rem;
        padding: 1rem 1.5rem;
        border-top: 1px solid var(--color-slate-200);
        background-color: var(--color-slate-50);
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    @media (max-width: 1399px) {
        dialog .dialog-content {
            width: 70vw;
        }
    }
    @media (max-width: 1200px) {
        dialog .dialog-content {
            width: 80vw;
        }
    }
    @media (max-width: 767px) {
        dialog .dialog-content {
            width: 100%;
            height: 100%;
        }
    }
</style>